import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/core/services/token.service';
import { HasPermissionDirective } from 'src/app/directives/has-permission.directive';
import { MaterialModule } from 'src/app/material.module';
import { ApiMessageService } from 'src/app/shared/services/api-message.service';
import { ConstantsService } from 'src/app/shared/services/constants.service';
import { environment } from 'src/environments/environment';
import { DeleteDetailsDailogueComponent } from './delete-details-dailogue/delete-details-dailogue.component';
import { ContactDetail } from '../../../models/contact/contactDetail';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SysService } from '../../../services/sys.service';


@Component({
  selector: 'app-contact-detail-list',
  standalone: true,
  imports: [
    MaterialModule,
    TablerIconsModule,
    MatNativeDateModule,
    NgScrollbarModule,
    CommonModule,
    RouterModule,
    TranslateModule,
    HasPermissionDirective
  ],
  templateUrl: './contact-detail-list.component.html'
})
export class ContactDetailListComponent implements AfterViewInit {
  @Output() onUpdate = new EventEmitter<void>();
  @ViewChild(MatTable, { static: false }) table: MatTable<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  contactDetails: MatTableDataSource<ContactDetail> = new MatTableDataSource<ContactDetail>([]);
  imageBaseUrl = environment.imageBaseUrl;
  searchText: any;
  displayedColumns: string[] = [
    'contactType',
    'contactValue',
    'orderNumber',
    'status',
    'action'
  ];
  loading: boolean = false;
  userId: number;
  langCode: string;
  lookupPermissions: any

  constructor(
    private sharedService: SharedService,
    private sysService : SysService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private tokenService: TokenService,
    public permissions: ConstantsService,
    public apiMessageService: ApiMessageService
  ) {
    let lang: any = localStorage.getItem('lang');
    let langObj: any;
    if (lang != undefined && lang != null) {

      langObj = JSON.parse(lang);
      this.langCode = langObj.code;
    }
    else {
      this.langCode = 'ar';
    }

    this.translate.use(this.langCode);
    this.userId = this.tokenService.getUserIdFromToken();
    this.lookupPermissions = this.permissions.permissions.SysLookup;
  }

  ngAfterViewInit(): void {
    this.contactDetails.paginator = this.paginator; // Assign paginator
    this.contactDetails.sort = this.sort;
  }

  // get active contact Details
  getActiveContactDetails(contactInfoId: number) {
    this.loading = true; // Start loading
    this.sysService.getContactDetailsByContactInfoId("contact/detail", contactInfoId).subscribe({
      next: (response) => {
        if (response.isSuccess) {
          this.contactDetails.data = response.data;

        } else if (response.isFailure) {
          this.apiMessageService.getMessages(response.errors);
          this.loading = false
        }
      },
      error: (error) => {
        this.apiMessageService.handleError(error);
        this.loading = false
      },
      complete: () => {
        (setTimeout(() => {
          this.contactDetails.paginator = this.paginator;
          this.contactDetails.sort = this.sort;
        }, 2000));
        this.loading = false; // Stop loading
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.contactDetails.filter = filterValue;
  }

  onupdate(action: string, element: any) {
    const data = { action, ...element }
    this.onUpdate.emit(data);
  }

  openDialog(action: string, obj: any): void {
    const dialogData = (typeof obj === 'object') ? { ...obj, action } : { action, id: obj };
    obj.langCode = this.langCode
    const dialogRef = this.dialog.open(DeleteDetailsDailogueComponent, {
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.event === 'Delete') {
        this.updateStatus(obj)
      } else if (result.event === 'Cancel') {

      }
    });
  }

  updateStatus(item: any) {
    this.sharedService.updateStatus("contact/detail", item.id, true).subscribe({
      next: (result) => {
        if (result.isSuccess) {
          this.apiMessageService.getMessage(result.message);
        } else if (result.isFailure) {
          this.apiMessageService.getMessages(result.errors);
        }
      },
      error: (err) => {
        this.apiMessageService.handleError(err);
        this.loading = false
      },
      complete: () => {
        this.loading = false; // Stop loading
        this.getActiveContactDetails(item.contactInfoId)
      }
    });
  }
}
